import instance from "../../utils/axios";

// Convert payload into URLSearchParams FormData
const toFormData = (payload) => {
  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) => formData.append(k, v ?? ""));
  return formData;
};

// SAVE
export const saveCampusVideo = async (payload) => {
  const res = await instance.post("/churches/campuses/campusvideos/save", toFormData(payload));
  return res.data;
};

// UPDATE
export const updateCampusVideo = async (payload) => {
  const res = await instance.post("/churches/campuses/campusvideos/update", toFormData(payload));
  return res.data;
};

// DELETE
export const deleteCampusVideo = async (payload) => {
  const fd = new URLSearchParams();
  fd.append("_id", payload._id);
  fd.append("campusObjId", payload.campusObjId);
  fd.append("campusVideoObjId", payload.campusVideoObjId);

  const res = await instance.post("/churches/campuses/campusvideos/delete", fd);
  return res.data;
};

// READ
export const readCampusVideos = async (payload) => {
  const res = await instance.post("/churches/campuses/campusvideos/read", toFormData(payload));
  return res.data;
};
